import VocHeaderDownload from "./src/main"

/* istanbul ignore next */
VocHeaderDownload.install = function (Vue) {
  Vue.component(VocHeaderDownload.name, VocHeaderDownload)
}

export default VocHeaderDownload
